import { supabase } from "../supabaseClient";
import { Post } from "../types/api/Post";
import { setup_notifications } from "./setup_notification";

export async function schedule_delete(post: Post) {
  await setup_notifications("cancel", post);

  await supabase.from("posts_media").delete().eq("post", post.id);
  await supabase.from("posts_for_feeds").delete().eq("post", post.id);
  await supabase.from("posts").delete().eq("id", post.id);
}
